// extracted by mini-css-extract-plugin
module.exports = {"placeholderBox":"EditOrganizationPage_placeholderBox__1NQoc","localityPicker":"EditOrganizationPage_localityPicker__3NU8R"};